import { sessionStorageKeys } from './sessionStorageKeys';

export default (appLinks) => {
    const stringifiedAppLinks = JSON.stringify(appLinks);
    localStorage.setItem(sessionStorageKeys.whitelistClientData, stringifiedAppLinks);
}